import moment from "moment";
import MenuBar from "../../menu/MenuBar";
import { Select, DatePicker, Button, Spin, Tag, message, Tabs } from "antd";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getDataPost_2 } from "../../../data/allfunction_2";
import ReportAllByAgent from "./ReportAllByAgent";
import ReportAllByAgentAndConId from "./ReportAllByAgentAndConId";
const ip = process.env.REACT_APP_IP;
const { TabPane } = Tabs;
const dateFormat = "DD-MM-YYYY";
function AccNonMotor() {
  const [agents, setAgents] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  const userRedux = useSelector((state) => {
    return state.user;
  });

  return (
    <div>
      <>
        <MenuBar />
        <div className="container text-center mt-3">
          <h4>ລາຍງານການຂາຍປະກັນໄພ HPA PA ITI ທັງໝົ້ດ</h4>
        </div>
        <div className="container-fluid">
          <Tabs defaultActiveKey="1">
            <TabPane tab="ລາຍງານສັນຍາທັງໝົ້ດຕາມຕົວແທນ" key="1">
              <ReportAllByAgent userRedux={userRedux} />
              
            </TabPane>
            <TabPane tab="ລາຍງານສັນຍາທັງໝົ້ດຕາມເລກທີສັນຍາ" key="2">
             <ReportAllByAgentAndConId userRedux={userRedux}/>
            </TabPane>
          </Tabs>
        </div>
      </>
    </div>
  );
}

export default AccNonMotor;

